import {
    // RegisteredRouter,
    UseNavigateResult,
    // RouteIds,
    // here is the only place where we can load the tanstack useNavigate
    // eslint-disable-next-line no-restricted-imports
    useNavigate as useTanstackNavigate,
} from '@tanstack/react-router'
import { useCallback } from 'react'

import { useExtractRootSearchParams } from './useExtractRootSearchParams'

// type FromIds = Extract<RouteIds<RegisteredRouter['routeTree']>, string>

export const useNavigate = (): UseNavigateResult<string> => {
    const tanstackNavigate = useTanstackNavigate()
    const extractRootSearchParams = useExtractRootSearchParams()

    return useCallback(
        (params) => {
            const { search } = params

            return tanstackNavigate(
                // @ts-expect-error this is right, not sure why TS is complaining
                {
                    ...params,
                    search: (previous) => {
                        const rootSearchParams = extractRootSearchParams(previous)

                        if (search) {
                            if (typeof search === 'function') {
                                return {
                                    ...rootSearchParams,
                                    ...search(previous),
                                }
                            }
                            if (typeof search === 'object') {
                                return {
                                    ...rootSearchParams,
                                    ...search,
                                }
                            }
                            if (typeof search === 'boolean') {
                                return previous
                            }
                        }

                        return rootSearchParams
                    },
                }
            )
        },
        [tanstackNavigate, extractRootSearchParams]
    )
}
